import React from 'react';
import { useTranslation } from 'react-i18next';

const HomeDeliveryFaq = () => {
  const { t } = useTranslation();

  return (
    <div className="faqContainer">
      <h2 className="textCenter">{t('Frequently asked questions')}:</h2>
      <div className="faqQuestionAnswer">
        <div className="faqColumn">
          <div className="faqWrap">
            <h3 className="float-left fullwidth">
              <strong>{t('Question')}: </strong>
              {t('What drugs are eligible for home delivery?')}
            </h3>
            <span className="fullwidth">
              <strong>{t('Answer')}: </strong>
              {t(
                'Many of our most popular drugs are eligible To check, look up a specific drug using the search bar You’ll see a big home delivery button and the GeniusRx logo if it’s eligible.'
              )}
            </span>
          </div>
          <div className="faqWrap">
            <h3 className="float-left fullwidth">
              <strong>{t('Question')}: </strong>{' '}
              {t('Do I need a valid a prescription?')}
            </h3>
            <span className="fullwidth">
              <strong>{t('Answer')}: </strong>
              {t(
                'Yes, an existing and valid prescription is required for home delivery.'
              )}
            </span>
          </div>
        </div>
        <div className="faqColumn">
          <div className="faqWrap">
            <h3 className="float-left fullwidth">
              <strong> {t('Question')}: </strong>
              {t('What information will I need to provide?')}
            </h3>
            <span className="fullwidth">
              <strong> {t('Answer')}: </strong>
              {t(
                'To get your existing prescription transferred to GeniusRx you’ll need to answer some simple questions about your medical history and any current medications you’re taking. You’ll also need to make a free account on SingleCare (if you haven’t already).'
              )}
            </span>
          </div>
          <div className="faqWrap">
            <h3 className="float-left fullwidth">
              <strong> {t('Question')}: </strong> {t('What is GeniusRx?')}
            </h3>
            <span className="fullwidth">
              <strong> {t('Answer')}: </strong>
              {t(
                'GeniusRx is SingleCare’s trusted home delivery partner and an accredited U.S. Pharmacy through NABP, dot.pharmacy, and LegitScript. GeniusRx operates and delivers to all 50 states.'
              )}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomeDeliveryFaq;
